/**
 * Lightbox fuer die Gravur-Vorschau im Cart-Drawer (snippets/cart-nested-addons.liquid).
 * Klick auf das Vorschau-Thumbnail ([data-cart-preview-zoom]) zeigt das Bild
 * vergroessert UEBER dem Drawer; der Drawer bleibt offen.
 *
 * - Ein einziges Element an document.body: ueberlebt das Re-Rendern des Drawers
 *   per Section Rendering API (innerHTML-Replace in app.js) und wird nicht vom
 *   Drawer-Overflow/Transform geclippt.
 * - Oeffnen ist auf document delegiert (Capture-Phase), damit es nach jedem
 *   Re-Render weiter funktioniert und kein Drawer-Handler den Klick sieht.
 * - Escape: der Drawer (PanelClose in app.js) lauscht auf document "keyup" in
 *   der Bubble-Phase. Wir schliessen auf "keydown" und schlucken keydown + keyup
 *   in der Capture-Phase per stopImmediatePropagation, damit der Drawer nicht
 *   mitschliesst. Backdrop-Klick liegt ausserhalb von .click-capture und wird
 *   zusaetzlich gestoppt.
 * - Body-Scroll: body.open-cc sperrt ihn bereits; hier wird nichts entsperrt.
 * - Shopify-CDN-URLs werden in groesserer Variante (width=1000, 2x der
 *   maximalen Darstellungsbreite von 500px) geladen.
 */
(function () {
  var FADE_MS = 180;
  var SWIPE_CLOSE_PX = 80;
  var CDN_WIDTH = 1000;

  var CLOSE_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M3 3l10 10M13 3L3 13"/></svg>';

  var lightbox = null;
  var card, img, caption, closeBtn;
  var isOpen = false;
  var trigger = null;
  var swallowEscapeKeyup = false;
  var closeTimer = null;
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function fadeDuration() {
    return reducedMotion && reducedMotion.matches ? 0 : FADE_MS;
  }

  function build() {
    if (lightbox) return;
    lightbox = document.createElement('div');
    lightbox.className = 'cart-preview-lightbox';
    lightbox.hidden = true;
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Vorschau der Personalisierung');
    lightbox.innerHTML =
      '<div class="cart-preview-lightbox__backdrop" data-cart-preview-close></div>' +
      '<div class="cart-preview-lightbox__card">' +
        '<button type="button" class="cart-preview-lightbox__close" aria-label="Vorschau schließen" data-cart-preview-close>' + CLOSE_ICON + '</button>' +
        // Innerer Rahmen clippt Bild + Leiste auf den Radius; der Close-Button
        // sitzt ausserhalb davon und ragt ueber die Kartenecke hinaus.
        '<div class="cart-preview-lightbox__frame">' +
          '<div class="cart-preview-lightbox__stage">' +
            '<span class="cart-preview-lightbox__spinner" aria-hidden="true"></span>' +
            '<img class="cart-preview-lightbox__img" alt="" draggable="false">' +
            '<p class="cart-preview-lightbox__error">Die Vorschau konnte nicht geladen werden.</p>' +
          '</div>' +
          '<p class="cart-preview-lightbox__caption"></p>' +
        '</div>' +
      '</div>';
    document.body.appendChild(lightbox);

    card = lightbox.querySelector('.cart-preview-lightbox__card');
    img = lightbox.querySelector('.cart-preview-lightbox__img');
    caption = lightbox.querySelector('.cart-preview-lightbox__caption');
    closeBtn = lightbox.querySelector('.cart-preview-lightbox__close');

    img.addEventListener('load', function () {
      lightbox.classList.remove('is-loading');
    });
    img.addEventListener('error', function () {
      if (!img.getAttribute('src')) return;
      lightbox.classList.remove('is-loading');
      lightbox.classList.add('has-error');
    });

    // Klicks innerhalb der Lightbox bleiben hier: kein Drawer-/Theme-Handler
    // (z. B. Outside-Click) darf sie sehen.
    lightbox.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target.closest('[data-cart-preview-close]')) {
        e.preventDefault();
        close();
      }
    });

    bindSwipe();
  }

  /**
   * Groessere Variante fuer Shopify-CDN-Bilder; alles andere unveraendert.
   */
  function largeSrc(src) {
    try {
      var url = new URL(src, window.location.href);
      var isShopifyCdn = /(^|\.)cdn\.shopify\.com$/i.test(url.hostname) || /\/cdn\/shop\//.test(url.pathname);
      if (!isShopifyCdn) return src;
      if (!/\.(png|jpe?g|webp|gif|avif)$/i.test(url.pathname)) return src;
      url.searchParams.set('width', String(CDN_WIDTH));
      return url.toString();
    } catch (err) {
      return src;
    }
  }

  function open(button, viaKeyboard) {
    build();
    var src = button.getAttribute('data-preview-src');
    if (!src) return;
    // Fokus-Ring am X nur, wenn per Tastatur geoeffnet (nicht bei Klick/Tap)
    lightbox.classList.toggle('is-keyboard', !!viaKeyboard);
    var side = button.getAttribute('data-preview-side') || '';

    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    trigger = button;

    // Beschriftung: nur die Seite ("Vorderseite" / "Rückseite")
    // Ohne Seitenangabe (kein Full-Custom-Shaker) entfaellt die Titelleiste
    caption.textContent = side;
    caption.hidden = !side;
    img.alt = side ? 'Vorschau ' + side : 'Vorschau';

    lightbox.classList.remove('has-error');
    lightbox.classList.add('is-loading');
    img.removeAttribute('src');
    img.src = largeSrc(src);
    if (img.complete && img.naturalWidth > 0) lightbox.classList.remove('is-loading');

    card.style.removeProperty('--swipe-y');
    lightbox.hidden = false;
    isOpen = true;
    // Reflow, damit die Transition opacity/scale auch beim ersten Oeffnen laeuft
    void lightbox.offsetWidth;
    lightbox.classList.add('is-open');
    closeBtn.focus();
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    lightbox.classList.remove('is-open');

    // Fokus zurueck auf den Ausloeser; ist er durch ein Re-Render weg, auf den Drawer
    var target = trigger && trigger.isConnected ? trigger : document.getElementById('Cart-Drawer');
    trigger = null;
    if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });

    var hide = function () {
      closeTimer = null;
      if (isOpen) return;
      lightbox.hidden = true;
      lightbox.classList.remove('is-loading', 'has-error');
      img.removeAttribute('src');
      card.style.removeProperty('--swipe-y');
    };
    var ms = fadeDuration();
    if (ms === 0) hide();
    else closeTimer = setTimeout(hide, ms + 20);
  }

  /**
   * Swipe-down auf Mobile schliesst; bei zwei Fingern (Pinch-Zoom) passiert nichts.
   */
  function bindSwipe() {
    var startY = null;
    var startX = null;
    var dragging = false;

    card.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { startY = null; return; }
      startY = e.touches[0].clientY;
      startX = e.touches[0].clientX;
      dragging = false;
    }, { passive: true });

    card.addEventListener('touchmove', function (e) {
      if (startY === null || e.touches.length !== 1) { startY = null; return; }
      var dy = e.touches[0].clientY - startY;
      var dx = e.touches[0].clientX - startX;
      if (!dragging && Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) dragging = true;
      if (!dragging) return;
      card.style.setProperty('--swipe-y', Math.max(0, dy) + 'px');
    }, { passive: true });

    var end = function (e) {
      if (startY === null) return;
      var touch = e.changedTouches && e.changedTouches[0];
      var dy = touch ? touch.clientY - startY : 0;
      startY = null;
      if (dragging && dy > SWIPE_CLOSE_PX) {
        close();
      } else {
        card.style.removeProperty('--swipe-y');
      }
      dragging = false;
    };
    card.addEventListener('touchend', end);
    card.addEventListener('touchcancel', end);
  }

  function focusableInLightbox() {
    return Array.prototype.filter.call(
      lightbox.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
  }

  // Oeffnen: delegiert, Capture-Phase, damit es nach jedem Drawer-Re-Render
  // weiter funktioniert und kein Drawer-/Link-Handler den Klick mitbekommt.
  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('[data-cart-preview-zoom]');
    if (!button) return;
    e.preventDefault();
    e.stopPropagation();
    // detail === 0: Klick wurde per Enter/Leertaste ausgeloest
    open(button, e.detail === 0);
  }, true);

  // Tastatur: Escape schliesst nur die Lightbox, Tab bleibt in der Lightbox
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    var key = e.key || e.code;
    if (key === 'Escape' || key === 'Esc') {
      e.preventDefault();
      e.stopImmediatePropagation();
      swallowEscapeKeyup = true;
      close();
      return;
    }
    if (key === 'Tab') {
      lightbox.classList.add('is-keyboard');
      var items = focusableInLightbox();
      if (!items.length) { e.preventDefault(); return; }
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || !lightbox.contains(document.activeElement))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !lightbox.contains(document.activeElement))) {
        e.preventDefault();
        first.focus();
      }
    }
  }, true);

  // Das zum Schliessen gehoerende keyup (und jedes Escape-keyup bei offener
  // Lightbox) darf PanelClose in app.js nicht erreichen, sonst geht der Drawer zu.
  document.addEventListener('keyup', function (e) {
    var key = e.key || e.code;
    if (key !== 'Escape' && key !== 'Esc') return;
    if (isOpen || swallowEscapeKeyup) {
      swallowEscapeKeyup = false;
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);

  // Fokus-Falle gegen programmatische Fokuswechsel von aussen (z. B. Drawer-Refresh)
  document.addEventListener('focusin', function (e) {
    if (!isOpen || lightbox.contains(e.target)) return;
    closeBtn.focus();
  });
})();
